import { FC, Fragment } from "react";
import Stack from "@mui/material/Stack";
import { capitalize } from "@mui/material";
import { BudgetDetailsSectionWrapper } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/common/BudgetDetailsSectionWrapper";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { BudgetDetailsAccumulatedCostChipsGroup } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsAccumulatedCostChipsGroup";
import { BudgetDetailsAccumulatedCostChart } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsAccumulatedCostChart";
import { BudgetDetailsAccumulatedCostDateSelect } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsAccumulatedCostDateSelect";
import { budgetDetailsNotStartedSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsNotStartedSelector";
import { BudgetDetailsNotStarted } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsNotStarted";

export const BudgetDetailsAccumulatedCostSection: FC = () => {
  const period = useAppSelector(budgetDetailsPeriodSelector);
  const title = `${capitalize(period ?? "")} Accumulated Cost`;
  const notStarted = useAppSelector(budgetDetailsNotStartedSelector);

  return (
    <BudgetDetailsSectionWrapper
      title={title}
      action={<BudgetDetailsAccumulatedCostDateSelect />}
    >
      <Stack width="100%" height={302} p={1}>
        {notStarted ? (
          <BudgetDetailsNotStarted />
        ) : (
          <Fragment>
            <BudgetDetailsAccumulatedCostChipsGroup />
            <BudgetDetailsAccumulatedCostChart />
          </Fragment>
        )}
      </Stack>
    </BudgetDetailsSectionWrapper>
  );
};
